import React from 'react';
import './styles.css';
import './BibleList.css';

function BibleList({ title, type, books }) {
  return (
    <div className="section bible-list">
      <h1><span className="bible-list__gold">{title}</span></h1>
      <div>
        {books.map(([route, displayName]) => (
          <div className="li" key={route}>
            <a href={`/bible/${route}?type=${type}`}>
              <span className="bible-list__gold">{type === 'en' ? route : displayName}</span>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BibleList;
